
const ipServer = 'https://stip-biodimetre-v2.lille.inria.fr:5001';



const fetchRegion = () => {
    var url = ipServer + '/region'
    return fetch(url, {
        method: 'GET',
        mode: 'cors',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchRegion - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchRegion - ERROR")
        error.text()
    });

}

const fetchDistrictCoordinates = () => {
    var url = ipServer + '/district'
    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchDistrictCoordinates - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchDistrictCoordinates - ERROR")
        error.text()
    });

}


const fetchPointsOfInterest = () => {
    var url = ipServer + '/pois'

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchPointsOfInterest - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchPointsOfInterest - ERROR")
        error.text()
    });
      
}

const fetchSensors = () => {

    var url = ipServer + '/sensors'

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchSensors - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchSensors - ERROR")
        error.text()
    });

}

const fetchFauneObservations = (period) => {

    var url = ipServer + '/fauneobservations/'+period
    console.log("entree fetch faune obs")
    console.log(period);
    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchFauneObservations - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchFauneObservations - ERROR")
        error.text()
    });

}

const fetchFloreObservations = (period) => {

    var url = ipServer + '/floreobservations/'+period

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchFloreObservations - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchFloreObservations - ERROR")
        error.text()
    });

}


const fetchPointOfInterest = (index) => {

    var url = ipServer + '/poi/'+ index;

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchPointOfInterest - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchPointOfInterest - ERROR")
        error.text()
    });

}

const fetchSensor = (index) => {

    var url = ipServer + '/sensor/' + index;

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchSensor - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchSensor - ERROR")
        error.text()
    });
    
}

const fetchFauneObservation = (index) => {

    var url = ipServer + '/fauneobservation/'+ index;

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchFauneObservation - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchFauneObservation - ERROR")
        error.text()
    });

}

const fetchFloreObservation = (index) => {

    var url = ipServer + '/floreobservation/'+ index;

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchFloreObservation - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchFloreObservation - ERROR")
        error.text()
    });
    
}

const getImage = (picture_url) => {
    var url = ipServer +"/"+ picture_url;
    console.log(url);
    return url;
}

const getSound = (sound_url) => {
    var url = ipServer +"/"+ sound_url;
    console.log(url);
    return url;
}




const fetchNews = (fromindex, toindex) => {

    var url = ipServer + '/articles/'+ fromindex + '&' + toindex;

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchNews - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchNews - ERROR")
        error.text()
    });

}

const fetchSensorsLink = () => { 

    var url = ipServer + '/sensorsdashboard';

    return fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
    })
    .then((response) => response.json())
    .then((json) => {
        console.log("API : fetchSensorsLink - OK");
        return json;
    })
    .catch((error) => {
        console.log("API : fetchfetchSensorsLinkSensor - ERROR")
        error.text()
    });

}





export {fetchRegion, fetchDistrictCoordinates, fetchPointsOfInterest, fetchFauneObservations, fetchSensors, fetchFloreObservations, fetchPointOfInterest, fetchFauneObservation, fetchFloreObservation, fetchSensor, getImage, getSound, fetchNews, fetchSensorsLink};